import { h } from 'preact'
import PropTypes from 'prop-types'
import { CARD_FIELDS } from '../../../../constants/card'
import Input from '../../../Common/Input'
import { useTranslations } from '../../../../hooks/useTranslations'
import { AUTOCOMPLETE_VALUES } from '../../../../constants/autocompleteValues'
import { getSelectionText } from '../../../../helpers/common'

const CardholderName = ({ register, setValue, errors }) => {
  const l10n = useTranslations()

  const maxLength = 35

  const handleKeyPress = e => {
    const value = e?.target?.value
    const text = value.replace(/\s/g, '')

    const lengthValidation =
      text?.length >= maxLength && getSelectionText().length !== value.length

    if (!/[^\~\%\^\*\=\`\,\.\_\$]+/.test(e.key) || lengthValidation) {
      e.preventDefault()
    }
  }

  return (
    <Input
      label={l10n.t('Name on card')}
      inputProps={{
        'data-apexx': 'card_holder_name',
        'data-testid': 'cardholder-name',
        name: 'card_holder_name',
        id: CARD_FIELDS.cardholderName,
        onKeyPress: handleKeyPress,
        autocomplete: AUTOCOMPLETE_VALUES.CARD_CARDHOLDER_NAME,
        ...register(CARD_FIELDS.cardholderName, {
          required: true,
          pattern: /^(?!.*[,]{2})[A-Za-z\s\-.,'’‘ÆæØøÅåÄäÖö]+$/,
        }),
      }}
      hasError={Boolean(errors[CARD_FIELDS.cardholderName])}
      errorMessage={l10n.t('Please enter the name as it appears on the card')}
    />
  )
}

CardholderName.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

export default CardholderName
